module.exports = __webpack_public_path__ + "static/media/22.5cdd5bd7.JPG";